import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import "./index.scss"
import Header from './components/header/Header';
import Menu from './components/menu/Menu';
import Sidebar from './components/sidebar/Sidebar';
import Home from './pages/home/Home';
import Oops from './pages/oops/Oops';
import Settings from './pages/settings/Settings';
import Reset from './pages/auth/Reset';
import Signup from './pages/auth/Signup';
import Login from './pages/auth/Login';
import Account from './pages/account/Account';
import Shop from './pages/shop/Shop';
import Dashboard from './pages/dashboard/Dashboard';
import Search from './pages/search/Search';
import Preloader from './components/loader/Preloader';
import { useEffect, useState } from 'react';
import Nav from './components/nav/Nav';
import EditAccount from './pages/account/EditAcount';
import Cart from './pages/cart/Cart';
import Product from './pages/product/Product';
import BigImg from './components/bigImg/BigImg';
import { useReducer } from 'react';
import UserContext from './frontendTestContext/UserContext';
import BecomeSellerToView from './components/unavailable/BecomeSellerToView';
import Faqs from './pages/faqs/Faqs';
import MiniLoader from './components/loader/MiniLoader';
import Seller from './components/seller/Seller';
import axios from 'axios';
import LoginToView from './components/unavailable/LoginToView';
import BecomeASeller from './pages/seller/BecomeASeller';
import NewProduct from './pages/new-product/NewProduct';
import EditProduct from './pages/edit-product/EditProduct';
import DeleteProduct from './pages/delete-product/DeleteProduct';
import OopsX from './pages/oops/OopsX';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const [isLoading, setIsLoading] = useState(true)
  const [showMenu, setShowMenu] = useState(false)
  const [showbigImg, setShowBigImg] = useState(false)
  const [previewSeller, setPreviewSeller] = useState(false)
  const [bigImgUrl, setBigImgUrl] = useState("./image-not-found.png")
  const [search, setSearch] = useState("")
  const [miniLoading, setMiniLoading] = useState(false)
  const [maxLoading, setMaxLoading] = useState(false)
  const [maxmaxLoading, setMaxMaxLoading] = useState(false)
  const [handleError, setHandleError] = useState({
    isError: false,
    errorDetails: {
      message: "...",
      status: "...",
      requestType: "",
      endpoint: ""
    }
  })
  const navigate = useNavigate()
  
  // const appInfo = {
  //   weburl: "https://shoptinga-demo.netlify.app"
  // }
  const avatarImages=[
    "signup",
    "bear",
    "boy",
    "cat",
    "empathy",
    "gamer",
    "man",
    "panda",
  ]

  const notificationHandling =  (message, type)=>{
    console.log(message, type)
    
    if(type==="success"){
      toast.success(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }

    if(type==="error"){
      toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }

    if(type==="warn"){
      toast.warn(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }

    if(type==="info"){
      toast.info(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  }
  
  const initialState = {
    isLoggedIn: false,
    user: {
      isSeller: false,
      isBanned: false,
      isSuspended: false,
      isDisabled: false,
      isAwaitingDeletion: false,
      userId : "",
      userImg: `./${avatarImages[0]}.png`,
      userName: "",
      userAvatar: 0,
      firstName: "",
      surName: "",
      userEmail : "",
      userPhone: "",
      purchases: [],
      sellerInfo: {
        info: {
          totalEarnings: "",
          cryptoWalletId: "",
          cryptoType: "",
          bankAccount: "",
          bankName: "",
          commision: "",
          totalSales: "....",
          productsCreated: "....",
          bio: ""
        },
        productsCreated: [
        ]
      }
    },
    shop: {
      products: []
    },
    cart: {
      items: [
      ]
    },
    functions: {
      handleNotification: (message, type)=>{
        notificationHandling(message, type)
      }
    }
  }

  const fetchUserData = async () => {
    const refresh = localStorage.getItem('refresh');
    if(refresh){
      try {
        const data = {
          "refresh": refresh,
        }
        const response = await axios.post(`https://shoptinga.onrender.com/api/auth/re-login/`, 
          data, 
          {
            headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-CSRFToken': 'uPI26MUqydFtbtfOjm2eLDK6GVnuigxrMaDKInwA4Yv0FypyDKfN6PKjA2BXwhwN'
            }
          }
        );
        const newAccess = response.data.access
        localStorage.setItem("access", newAccess)
        // console.log("Got New Access Token")
        if(newAccess){
          try {
            const response = await axios.get(`https://shoptinga.onrender.com/api/my-profile`, {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `JWT ${newAccess}`,
                'Accept': 'application/json',
              },
            });
            const userData = response.data;
            dispatch({type: "loginVerified", payload: userData})
            setMaxLoading(false)
            // console.log("User Loaded")
          } catch (error) {
            console.error(error.message);
            dispatch({type: "loginNotVerified"})
            setMaxLoading(false)
          }
        }
      } catch (error) {
        console.error(error.message);
        dispatch({type: "loginNotVerified"})
        setMaxLoading(false)
      }
    } else{
      console.log("no-access")
      setMaxLoading(false)
    }
  };

  const fetchUserDataX = async () => {
    const access = localStorage.getItem('access');

    if(access){
      try {
        const response = await axios.get(`https://shoptinga.onrender.com/api/my-profile`, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `JWT ${access}`,
            'Accept': 'application/json',
          },
        });
        const userData = response.data;
        console.log(userData)
        setMaxLoading(false)
        dispatch({type: "loginVerified", payload: userData})
      } catch (error) {
        console.error(error.message);
        dispatch({type: "loginNotConfirmed"})
        setMaxLoading(false)
      }
    } else{
      console.log("User not Loaded")
      setMaxLoading(false)
    }
  };

  const fetchProducts = async () => {
    try {
      const response = await axios.get('https://shoptinga.onrender.com/api/products/');
      const productList = response.data;
      const productListX = productList.reverse()

      const customizedProductList = productListX.map((product)=>{
        return (
          {
            productDetailsFromBackend:{
              productId: product.id,
              productName: product.title,
              productHeadline: product.description,
              productDateCreated: "2nd June 2023",
              productDateLastUpdated: "2nd June 2023",
              productCategory: product.category,
              productIsTrending: true,
              createdAt: product.created_at,
              productUrls:{
                productImgUrl: product.thumbnail,
                productUrl: product.slug,
                liveSite: "https://tertiux-linktree.netlify.app",
                gitHub: "https://github.com/tertiux/tertiux",
              },
              productOwner: {
                userName: "Creator",
                userId: product.creator
              },
              productMedia: {
                images: [
                  {
                    imageUrl: product.productImage,
                    imageName: "image2"
                  },
                ],
              },
              productFull: {
                productAbout: product.description,
                productHighlights: [
                  // {
                  //   highlightName: "Download reusable website templates",
                  // },
                ]
              },
              productPriceInDollar: product.price,
              hasBeenPurchasedByThisUser: false,
            },
            productDetailsFromBrowser:{
              hasBeenAddedToCart: false,
            }
          }
        )
      })

      dispatch({ type: 'fetch-products-success', payload: customizedProductList });
      setTimeout(()=>{
        setMiniLoading(false)
        setIsLoading(false)
      }, 500)
    } catch (error) {
      console.log("An error Occured")
      setHandleError({
        isError: true,
        errorDetails: {
          message: error.message,
          priorityMessage: "Network Error",
          requestType: "GET",
        }
      })
      setMiniLoading(false)
      setIsLoading(false)
      setTimeout(()=>{
        console.log("Error details:", handleError)
      }, 1500)
    }
  };

  const updateAppState = (state, action)=>{
    let prevList
    
    switch (action.type){
      
      case ("addToCart"):
        prevList = state.cart.items.filter((item)=>{
          return item.itemId !== action.target
        })
        state.functions.handleNotification(`Item has been added to cart`, "success")
        return {
          ...state,
          cart: {
            items: [
              ...prevList,
              {
                itemId: action.target
              }
            ]
          }
        }
        
        case ("removeFromCart"):
        state.functions.handleNotification(`Item has been removed from cart`, "success")
        const newCart = state.cart.items.filter((item)=>{
          return item.itemId !== action.target
        })
        return {
          ...state,
          cart: {
            items: [
              ...newCart
            ]
          }
        }
        
        case ("updateCart"):
          const cartItemsToSave = action.payload
          return {
            ...state,
            cart: {
              items: [
                ...cartItemsToSave
              ]
            }
          }

      case ("loaded"):
        fetchProducts()
        return {
          ...state
        }

      case ("getuser"):
        fetchUserData()
        return {
          ...state
        }
      
      case ("fetch-products-success"):
        const productList = action.payload
        return {
          ...state,
          shop: {
            ...state.shop,
            products: productList,
          }
        }

      case ("loginVerified"):
        const userData = action.payload
        const thisUser = userData[0]
        // console.log(thisUser)
        const sellerProducts = state.shop.products.map((item)=>{
            return(
              {
                productId: item.productDetailsFromBackend.productId,
                productThumbnail: item.productDetailsFromBackend.productUrls.productImgUrl,
                productName: item.productDetailsFromBackend.productName,
                productUrl: item.productDetailsFromBackend.productUrls.productUrl,
                productOwner: item.productDetailsFromBackend.productOwner.userId,
                productPrice: item.productDetailsFromBackend.productPriceInDollar
              }
            )
          })

        return {
          ...state,
          isLoggedIn: true,
          user: {
            isSeller: thisUser.is_seller,
            isBanned: false,
            isSuspended: false,
            isDisabled: false,
            isAwaitingDeletion: false,
            userId : thisUser.id,
            // profileId: thisUser.profile.id,
            userAvatar: thisUser.avatar,
            userImg: `https://subitenary2k23.netlify.app/${avatarImages[thisUser.avatar]}.png`,
            userName: thisUser.user.username,
            firstName: "",
            surName: "",
            userEmail : thisUser.user.email,
            userPhone: "",
            purchases: [
              ...thisUser.purchased_products
            ],
            sellerInfo: {
              info: {
                totalEarnings: thisUser.account_balance,
                cryptoWalletId: thisUser.crypto_wallet_id,
                cryptoType: thisUser.crypto_type,
                bankAccount: thisUser.bank_account,
                bankName: thisUser.bank_name,
                commision: thisUser.commision,
                totalSales: 300,
                productsCreated: 52,
                bio: thisUser.bio
              },
              productsCreated: [
                ...sellerProducts
              ]
            }
          },
        }
      
        case ("loginNotVerified"):
        return {
          ...state,
          isLoggedIn: false,
          user: {
            ...state.user,
            isSeller: false,
            isBanned: false,
            isSuspended: false,
            isDisabled: false,
            isAwaitingDeletion: false,
            userId : "......",
            userImg: ".......",
            userName: ".......",
            firstName: "...",
            surName: "....",
            userEmail : "...",
            userPhone: "....",
            userAvatar: 0,
            purchases: [
            ],
            sellerInfo: {
              info: {
                totalEarnings: "",
                cryptoWalletId: "",
                cryptoType: "",
                bankAccount: "",
                bankName: "",
                commision: "",
                totalSales: "....",
                productsCreated: "....",
                bio: ""
              },
              productsCreated: [
              ]
            }
          },
        }

        case ("loginNotConfirmed"):
          console.log("Refresh app to reflect changes")
          state.functions.handleNotification("Refesh app to reflect changes", "info")
          return {
            ...state,
        }

        case ("logout"):
          localStorage.removeItem("access")
          localStorage.removeItem("refresh")
          console.log("Logging Out")
          
          const logout = async () => {
            const url = 'https://shoptinga.onrender.com/api/auth/logout/';
            const headers = {
              'accept': 'application/json',
              'X-CSRFToken': 'uPI26MUqydFtbtfOjm2eLDK6GVnuigxrMaDKInwA4Yv0FypyDKfN6PKjA2BXwhwN',
            };
      
            try {
              await axios.post(url, {}, { headers });
              console.log("Logout successful");
              appState.functions.handleNotification("Logout successful", "success")
              // Perform any additional actions after successful logout
            } catch (error) {
              console.error('Error during logout:', error.message);
              // Handle logout error, if needed
            }
          };
      
          logout();

          navigate("/")
          return {
            ...state,
            isLoggedIn: false,
            user: {
              isSeller: false,
              isBanned: false,
              isSuspended: false,
              isDisabled: false,
              isAwaitingDeletion: false,
              userId : "......",
              userImg: ".......",
              userName: ".......",
              firstName: "...",
              userAvatar: 0,
              surName: "....",
              userEmail : "...",
              userPhone: "....",
              purchases: [
              ],
              sellerInfo: {
                info: {
                  totalEarnings: "",
                  cryptoWalletId: "",
                  cryptoType: "",
                  bankAccount: "",
                  bankName: "",
                  commision: "",
                  totalSales: "....",
                  productsCreated: "....",
                  bio: ""
                },
                productsCreated: [
                ]
              }            
            },
          }

      default:
        return state
    }
  }

  const location = useLocation()

  
  const [appState, dispatch] = useReducer(updateAppState, initialState)
  
  useEffect(()=>{
    setInterval(()=>{
      fetchUserData()
    }, 30000)

    setInterval(()=>{
      dispatch({type: "loaded"})
    }, 2000)
  },[])


  useEffect(()=>{
    if(appState.isLoggedIn === false){
      dispatch({type: "getuser"})
    }
    if(location.pathname === "/dashboard"){
      setTimeout(()=>{
        setMaxMaxLoading(false)
      }, 1000)
    }
  }, [appState.isLoggedIn, location.pathname])

  useEffect(()=>{
    if(appState.shop.products.length > 0){
      setTimeout(()=>{
        const cartData = appState.cart
        window.localStorage.setItem("cart-data", JSON.stringify(cartData.items))
      }, 500)
    }
  }, [appState])
  
  useEffect(()=>{
    const newCartData = window.localStorage.getItem("cart-data")
    const newCartDataParsed = JSON.parse(newCartData)
    if(newCartDataParsed){
      dispatch({type: "updateCart", payload: newCartDataParsed})
    }
    document.addEventListener("contextmenu", (e)=>{
      e.preventDefault()
    })
  }, [])
  
  
  useEffect(()=>{
    const productList = appState.shop.products;
    if(appState.shop.products.length > 0){
      const cartData = appState.cart
      const productsInCartX = productList.map((product) => {
          const hasBeenAddedToCart = cartData.items.some(
          (item) => item.itemId === product.productDetailsFromBackend.productId);
  
              return {
                  ...product,
                  productDetailsFromBrowser: {
                  ...product.productDetailsFromBrowser,
                  hasBeenAddedToCart: hasBeenAddedToCart,
              },
          };
      });
  
      const productsInCart = productsInCartX.filter((item)=>{
        return item.productDetailsFromBrowser.hasBeenAddedToCart === true
      })

      const newCartMini = productsInCart.map((product)=>{
        return ({
            itemId: product.productDetailsFromBackend.productId
        })
      })

      setTimeout(()=>{
          const newCartMiniParsed = JSON.stringify(newCartMini)
          localStorage.setItem("cart-data", newCartMiniParsed)
      }, 2000)
    }
  },[appState])
  
  useEffect(()=>{
    if(previewSeller && location.pathname.includes("product") !== true){
      setPreviewSeller(false)
    }
  }, [location.pathname, previewSeller])
  
  useEffect(()=>{
    const pathname = location.pathname
    if(pathname.includes("account/edit")){
      document.title = `Edit Account ~ Shoptinga: Digital marketplace for digital products`
    } else if(pathname.includes("account")){
      document.title = `Account ~ Shoptinga: Digital marketplace for digital products`
    } else if(pathname.includes("become-a-seller")){
      document.title = `Become a Seller ~ Shoptinga: Digital marketplace for digital products`
    } else if(pathname.includes("login")){
      document.title = `Login ~ Shoptinga: Digital marketplace for digital products`
    } else if(pathname.includes("signup")){
      document.title = `Signup ~ Shoptinga: Digital marketplace for digital products`
    } else if(pathname.includes("reset")){
      document.title = `Reset password ~ Shoptinga: Digital marketplace for digital products`
    } else if(pathname.includes("dashboard")){
      document.title = `Dashboard ~ Shoptinga: Digital marketplace for digital products`
    } else if(pathname.includes("search")){
      document.title = `Search ~ Shoptinga: Digital marketplace for digital products`
    } else if(pathname.includes("shop")){
      document.title = `Shop ~ Shoptinga: Digital marketplace for digital products`
    } else if(pathname.includes("cart")){
      document.title = `Cart ~ Shoptinga: Digital marketplace for digital products`
    } else {
      document.title = `Home ~ Shoptinga: Digital marketplace for digital products`
    }

  }, [location.pathname])
  
  function handleLoader(value, skip){
    setMiniLoading(value)
    
    if(skip){
        setTimeout(()=>{
          setMiniLoading(false)
        }, [1000])
    }
  }
  
  function handleMaxLoader(value){
    setMaxLoading(value)
  }

  function handleMaxMaxLoader(value){
    setMaxLoading(value)
  }

  useEffect(() => {
    const allLinks = document.querySelectorAll(".active");

    const handleClick = () => {
      // console.log("active clicked")
      const allDivs = document.querySelectorAll("div");
      const allContent = document.querySelectorAll(".content");
      allDivs.forEach((div) => {
        div.scrollTo({
          top: 0,
          behavior: "smooth" // Optional: Add smooth scrolling animation
        });
      });
      allContent.forEach((div) => {
        div.scrollTo({
          top: 0,
          behavior: "smooth" // Optional: Add smooth scrolling animation
        });
      });
    };
  
    allLinks.forEach((link) => {
      link.addEventListener("click", handleClick);
    });
  }, [location.pathname]);
  
  function logOut(){
    dispatch({type: "logout"})
  }

  async function checkOut(productid){
    setMaxLoading(true)
    const producttoBuy = [productid]
    try{
      const response = await axios.post(`https://shoptinga.onrender.com/api/create-checkout-session`, {product_ids: [...producttoBuy]});
      console.log(response.data)
      if (response.status === 200) {
        window.location.href = response.data.hosted_url;
        setMaxLoading(false)
      } else {
        alert('Failed to create checkout session. Please try again later.');
      }
      setMaxLoading(false)
      // navigate("/dashboard")
    } catch(error){
      console.error(error)
      setMaxLoading(false)
    }
  }
  
  return (
    <UserContext.Provider value={appState}>
        <div className={`app ${previewSeller && "preview-seller"} ${miniLoading && "mini-loading"} ${maxmaxLoading && "mini-loading"}  ${maxLoading && "mini-loading"} ${isLoading && "loading"} ${showMenu && "show-menu"}`}>

          <Header search={search} setSearch={setSearch} handleLoader={handleLoader}></Header>

          <Sidebar logOut={logOut} handleLoader={handleLoader}/>
          
          <Nav showMenu={()=>{
            setShowMenu(true)
          }} handleLoader={handleLoader}></Nav>
          
          <Menu logOut={logOut} hideMenu ={()=>{
            setShowMenu(false)
          }} handleLoader={handleLoader}></Menu>
          
          <BigImg bigImgUrl={bigImgUrl} showbigImg={showbigImg} hideBigImg={()=>{
            setShowBigImg(false)
            setTimeout(()=>{
              setBigImgUrl("./image-not-found.png")
            }, 600)
          }}/>
          
          <div onClick={()=>{
            setShowMenu(false)
          }} className='backdrop'></div>
          
          <Preloader></Preloader>
          
          <MiniLoader />
          
          <Seller handleLoader={handleLoader} closeSellerPreview={()=>{
            setPreviewSeller(false)
          }}/>
          
          <BecomeSellerToView />
          <LoginToView />

          {/* NOtification handling */}
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
          
          
          
          <Routes>

            <Route path='/' element={<Home handleLoader={handleLoader} addToCart={(productId)=>{
              dispatch({type: "addToCart", target: productId})
            }} removeFromCart={(productId)=>{
              dispatch({type: "removeFromCart", target: productId})
            }} />} />

            <Route path='/home' element={<Home handleLoader={handleLoader} addToCart={(productId)=>{
              dispatch({type: "addToCart", target: productId})
            }} removeFromCart={(productId)=>{
              dispatch({type: "removeFromCart", target: productId})
            }} />} />

            <Route path='/shop' element={<Shop addToCart={(productId)=>{
              dispatch({type: "addToCart", target: productId})
            }} removeFromCart={(productId)=>{
              dispatch({type: "removeFromCart", target: productId})
            }} handleLoader={handleLoader}/>} />

            <Route path='/dashboard' element={appState.isLoggedIn ? <Dashboard handleLoader={handleLoader}/> : <OopsX />} />

            <Route path='/search' element={<Search search={search} setSearch={setSearch} addToCart={(productId)=>{
              dispatch({type: "addToCart", target: productId})
            }} removeFromCart={(productId)=>{
              dispatch({type: "removeFromCart", target: productId})
            }} handleLoader={handleLoader} />} />

            <Route path='/cart' element={<Cart  removeFromCart={(productId)=>{
              dispatch({type: "removeFromCart", target: productId})
            }} handleMaxLoader={handleMaxLoader} handleLoader={handleLoader} />} />

            <Route path='/product/:productId' element={<Product showbigImg={(url)=>{
              setShowBigImg(true)
              setBigImgUrl(url)
            }} addToCart={(productId)=>{
              dispatch({type: "addToCart", target: productId})
            }} removeFromCart={(productId)=>{
              dispatch({type: "removeFromCart", target: productId})
            }} previewSeller={()=>{
              setPreviewSeller(true)
            }
            } checkOut={checkOut} handleLoader={handleLoader} />} />

            <Route path='/account' element={appState.isLoggedIn ? <Account handleLoader={handleLoader}/> : <OopsX />} />
            
            <Route path='/account/edit' element={appState.isLoggedIn ? <EditAccount handleLoader={handleMaxLoader} updateUser={()=>{
              fetchUserDataX()
            }}/> : <OopsX />} />
            
            <Route path='/login' element={<Login  logIn={()=>{dispatch({type: "getuser"})}} logOut={()=>{dispatch({type: "logout"})}} handleLoader={handleMaxLoader}  handleMinLoader={handleLoader} />} />
            
            <Route path='/signup' element={<Signup handleLoader={handleMaxLoader}  handleMinLoader={handleLoader}/>} />

            <Route path='/become-a-seller' element={appState.isLoggedIn ? <BecomeASeller handleLoader={handleMaxLoader} updateUser={()=>{
              fetchUserDataX()
            }}/> : <OopsX />} />
            
            <Route path='/reset' element={<Reset  reset={()=>{dispatch({type: "logout"})}} handleLoader={handleLoader} />} />

            <Route path='/dashboard/new-product' element={appState.isLoggedIn ? <NewProduct handleLoader={handleMaxMaxLoader} /> : <OopsX />} />

            <Route path='/dashboard/create-product' element={appState.isLoggedIn ? <NewProduct handleLoader={handleMaxMaxLoader} /> : <OopsX />} />
            
            <Route path='/dashboard/edit-product/:productId' element={appState.isLoggedIn ? <EditProduct handleLoader={handleMaxMaxLoader} /> : <OopsX />} />

            <Route path='/dashboard/delete-product/:productId' element={appState.isLoggedIn ? <DeleteProduct handleLoader={handleMaxMaxLoader} /> : <OopsX />} />
            
            <Route path='/settings' element={<Settings />} />
            
            <Route path='/faqs' element={<Faqs />} />
            
            <Route path='/*' element={<Oops dispatch={dispatch} />} />
          </Routes>
        </div>
    </UserContext.Provider>
  );
}

export default App;
